import { Heading } from '@makemydeal/dr-ui-bricks-components';

import type { PageDescriptionProps } from '../../types';

/**
 * PageDescription
 *
 * Shared page/section description built on top of the `Heading` component
 * from `ui-bricks-components`. Standardizes the default level/weight used
 * for page descriptions across Sales Check-In so consuming components don't
 * need to repeat the same `Heading` props.
 */
export const PageDescription = ({ children, 'data-testid': dataTestId = 'page-description' }: PageDescriptionProps) => (
    <Heading level={5} weight="regular" data-testid={dataTestId}>
        {children}
    </Heading>
);

export default PageDescription;
